module.exports = __webpack_public_path__ + "img/video_cam-01.7cf4c1c8.svg";